import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dashboard } from './Dashboard';
import { ModalAgregarTransaccion } from '../components/ModalAgregarTransaccion';
import { leerEnlaceApuntar } from '../utils/apuntarRapido';

/**
 * /apuntar?importe=…&comercio=…: lo que abren los Atajos de iOS y la
 * automatización de Wallet. El resumen de Finanzas con el formulario de gasto
 * encima, ya rellenado; al cerrarlo se queda en el resumen.
 */
export const Apuntar: React.FC = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const inicial = useMemo(() => leerEnlaceApuntar(search), [search]);
  return (
    <>
      <Dashboard />
      <ModalAgregarTransaccion key={search} inicial={inicial}
        onClose={() => navigate('/finanzas/dashboard', { replace: true })} />
    </>
  );
};
